import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          热门专题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          精选优质影视专题，一站式发现精彩内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-300"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}